export const HANDLE_TYPE_1 = 'type1';
export const HANDLE_TYPE_3 = 'type3';
export const HANDLE_TYPE_CUSTOMIZED = 'customized';
export const HANDLE_TYPE_DEFAULT = 'default';

const handleTypes = [
  HANDLE_TYPE_DEFAULT,
  HANDLE_TYPE_1,
  HANDLE_TYPE_3,
  HANDLE_TYPE_CUSTOMIZED,
];

export default handleTypes;
